import React from 'react'

import { Loading } from '@hhgtech/hhg-components'
import { Text } from '@hhgtech/hhg-components/mantine'
import { Close } from '@hhgtech/icons/core'
import { Missed } from '@hhgtech/icons/other'
import { Box, BoxProps, rem } from '@mantine/core'
import { useIntl } from 'react-intl'

import { Product } from 'interfaces/types/Ecommerce'

import useStyles from './index.styles'
import { BuyNowButtons } from '../buyNowButtons'

type Props = {
  /**
   * product
   */
  product: Product
  onClose?: () => void
} & BoxProps
const ProductCardBuyNowModal = ({
  onClose,
  product,
  styles,
  className,
  classNames,
  ...boxProps
}: Props) => {
  const { formatMessage: f } = useIntl()
  const { classes, cx } = useStyles(undefined, {
    name: 'ProductCardBuyNowModal',
    classNames,
    styles,
  })
  const { affiliates = [], slug } = product
  const url = `/shop/san-pham/${slug}/`

  return (
    <Box className={cx(classes.root, className)} {...boxProps}>
      <div className="title-container">
        <Text size="s3">
          {f({
            id: 'productCard.buyNowModal.title',
            defaultMessage: 'Lựa chọn mua hàng từ các nhà bán lẻ',
          })}
        </Text>
        <Close
          onClick={() => {
            onClose?.()
          }}
          style={{
            cursor: 'pointer',
          }}
        />
      </div>
      <div className="title-divider"></div>
      <Box
        component="a"
        href={url}
        target="_blank"
        className="image-info-wrapper"
      >
        <img
          loading="lazy"
          className="product-image"
          src={product.thumbnail}
          alt={product.name}
        />
        <Text size="p1">{product.name}</Text>
      </Box>
      {affiliates ? (
        <BuyNowButtons affiliates={affiliates || []} size="sm" />
      ) : (
        <Loading />
      )}
      <Box
        sx={(theme) => ({
          display: 'flex',
          gap: 8,
          color: theme.colors.green[8],
          marginTop: rem(20),
        })}
      >
        <Missed
          size={16}
          useCurrentColor
          style={{
            marginTop: rem(2),
          }}
        />
        <Text
          size="p4"
          sx={(theme) => ({ color: theme.colors.green[8] })}
          weight="regular"
        >
          {f({
            id: 'productCard.buyNowModal.info',
            defaultMessage:
              'Nhà bán lẻ có thể sẽ cung cấp thêm nhiều thuộc tính sản phẩm khác nhau cho bạn lựa chọn',
          })}
        </Text>
      </Box>
    </Box>
  )
}

export { ProductCardBuyNowModal }
